import * as React from "react";
import { SVGProps } from "react";
export const PencilStrokeIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.29199 17.5L11.688 14.083H16.625C17.097 14.083 17.4997 14.2497 17.833 14.583C18.1663 14.9163 18.333 15.3193 18.333 15.792C18.333 16.264 18.1663 16.6667 17.833 17C17.4997 17.3333 17.097 17.5 16.625 17.5H8.29199ZM3.41699 15.75H4.64599L11.646 8.75L10.417 7.521L3.41699 14.521V15.75ZM15.354 7.542L11.625 3.812L12.646 2.792C12.9933 2.44466 13.4063 2.271 13.885 2.271C14.3643 2.271 14.7777 2.44466 15.125 2.792L16.375 4.042C16.7083 4.37533 16.875 4.78833 16.875 5.281C16.875 5.77433 16.7083 6.18766 16.375 6.521L15.354 7.542ZM2.54199 17.5C2.30599 17.5 2.10099 17.4133 1.92699 17.24C1.75366 17.066 1.66699 16.861 1.66699 16.625V14.125C1.66699 14.0137 1.68766 13.906 1.72899 13.802C1.77099 13.698 1.83366 13.6043 1.91699 13.521L10.396 5.042L14.125 8.771L5.64599 17.25C5.56266 17.3333 5.46899 17.396 5.36499 17.438C5.26033 17.4793 5.15266 17.5 5.04199 17.5H2.54199Z"
            fill="currentColor"
        />
    </svg>
);
PencilStrokeIcon.displayName = "PencilStrokeIcon";
